import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Heart } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

const JANELLE_PHOTO = 'https://customer-assets.emergentagent.com/job_98f4c0a7-37e3-4eee-b45d-3c901b2920ec/artifacts/e2kpke7l_IMG_5756.jpeg';

export const AboutPage = () => {
  return (
    <div data-testid="about-page" className="min-h-screen bg-cream">
      <Navbar />

      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-5 gap-12 items-start">
            {/* Photo */}
            <div className="md:col-span-2 flex justify-center">
              <img
                src={JANELLE_PHOTO}
                alt="Janelle McGowan-Charles"
                data-testid="about-photo"
                className="w-64 h-80 object-cover rounded-2xl shadow-xl"
              />
            </div>

            {/* Story */}
            <div className="md:col-span-3">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 rounded-full mb-6">
                <Heart className="w-4 h-4 text-gold" />
                <span className="text-sm font-medium text-gold">My Story</span>
              </div>
              <h1 className="font-heading text-4xl text-charcoal mb-6">Hi, I'm Janelle</h1>
              
              <div className="space-y-4 text-charcoal-light leading-relaxed">
                <p>
                  I'm Janelle McGowan-Charles — a 32-year-old faith-led trauma recovery coach, author, and the 
                  founder of Purpose Reclaimed Coaching, based in London, UK.
                </p>
                <p>
                  I'm a proud mother of two beautiful girls, aged 3 and 5, and my world revolves around 
                  faith, family, and helping women heal.
                </p>
                <p>
                  I know what it feels like to carry the weight of something that was never yours to hold. 
                  I know the shame that whispers you're damaged. The guilt that says it was somehow your fault. 
                  The limiting beliefs that keep you small, silent, and stuck.
                </p>
                <p>
                  I know because I've lived it.
                </p>
                <p>
                  Since finding my journey with Christ, my life has changed so drastically. God led me to my 
                  true purpose and calling — supporting women to overcome sexual abuse trauma. My own journey 
                  through sexual abuse, trauma, and the long road to healing is what led me to this work. It 
                  wasn't easy. It wasn't quick. But with God's grace, the right support, and a refusal to let 
                  my past define my future — I found my breakthrough.
                </p>
                <p>
                  And now, I'm dedicated to helping other women find theirs.
                </p>
                <p>
                  Through Purpose Reclaimed Coaching, I work with women who are ready to stop surviving and 
                  start thriving. Women who are tired of carrying shame that doesn't belong to them. Women 
                  who know God has a purpose for their lives but can't see past the pain.
                </p>
                <p className="font-medium text-charcoal">
                  I see you. I believe you. And I'm here to walk this journey with you.
                </p>
              </div>

              <div className="mt-8 p-6 bg-sage/5 rounded-2xl">
                <h3 className="font-heading text-lg text-charcoal mb-3">My Mission</h3>
                <p className="text-sm text-charcoal-light italic">
                  To empower women who have experienced sexual abuse and trauma to heal through faith, 
                  break free from limiting beliefs, and step boldly into the purposeful life God has 
                  designed for them.
                </p>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link to="/coaching" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-sage text-white rounded-full font-medium hover:bg-sage-dark transition-all">
                  Work With Me <ArrowRight className="w-4 h-4" />
                </Link>
                <Link to="/purchase" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-sage border border-sage/20 rounded-full font-medium hover:bg-sage/5 transition-all">
                  Get the Ebook
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
